<template>
  <div class="side-component" :class="{ active: isOpen }">
    <div class="wrap">
      <div
        class="modal-backdrop"
        @click="close"
        :class="{ in: showComponent, out: !showComponent }"
      ></div>
      <section
        class="card"
        :class="{ in: showComponent, out: !showComponent }"
        v-watch-menu-state
      >
        <b-button class="btn btn-close" variant="white" @click="close">
          <i class="material-icons material-icons-arrow-forward">
            arrow_forward
          </i>
        </b-button>
        <div class="side-content" ref="sideContent">
          <slot></slot>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      showComponent: false,
    }
  },
  methods: {
    open() {
      this.isOpen = true
      setTimeout(() => (this.showComponent = true), 400)
    },
    close() {
      this.showComponent = false
      setTimeout(() => (this.isOpen = false), 400)
      this.$emit('close')
      this.$refs.sideContent.scrollTop = 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.side-component {
  bottom: 0;
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 1;

  .btn-close {
    align-items: center;
    border: 1px solid map-get($theme-colors, 'gray01');
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin: -22px;
    position: absolute;
    width: 48px;
    z-index: 1;

    .material-icons {
      cursor: pointer;
    }

    @media (max-width: 425px) {
      margin: -22px 0;
      width: 40px;
    }
  }

  .card {
    background: white;
    border-radius: 8px 0 0 8px;
    bottom: 0;
    max-width: 90vw;
    position: absolute;
    right: 0;
    top: 24px;
    transition: transform 0.3s ease;
    width: 945px;

    &.fix-175 {
      max-width: calc(100% - 390px);
    }

    &.fix-33 {
      max-width: calc(100% - 114px);
    }

    @media (max-width: 425px) {
      max-width: initial;
      width: 100%;

      &.fix-175,
      &.fix-33 {
        max-width: initial;
      }
    }

    .side-content {
      height: 100%;
      overflow: auto;
      width: 100%;
      max-height: calc(100vh - 50px);
    }
  }

  .modal-backdrop {
    opacity: 0;
    transition: opacity 1s ease;
    z-index: -1;
  }

  &.active {
    display: inline-block;
    z-index: 1;

    .card {
      transition: transform 0.4s ease;
      z-index: 1500;

      &.in {
        transform: translateX(0%);
      }
      &.out {
        transform: translateX(100%);
      }
    }

    .modal-backdrop {
      transition: opacity 0.4s ease;
      z-index: 1;

      &.in {
        opacity: 0.5;
      }
      &.out {
        opacity: 0;
      }
    }
  }
}
</style>
